import moment from 'moment';
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { CurrencyFormatWithTitle } from '../../../components/domainSpecific/currencyElements';

const createInvoiceTransactionsColumns = invoiceCurrency => [
  {
    key: 'transactionDate',
    title: <FormattedMessage id="invoice.transactionHistory.date" />,
    dataIndex: 'date',
    width: '15%',
    render: text => (
      <span className="text-uppercase">
        {moment(text, 'MM/DD/YYYY').format('MMM-DD-YYYY')}
      </span>
    ),
  },
  {
    key: 'transactionAction',
    title: <FormattedMessage id="invoice.transactionHistory.action" />,
    dataIndex: 'action',
    align: 'center',
    width: '27%',
  },
  {
    key: 'transactionAmount',
    title: <FormattedMessage id="invoice.transactionHistory.amount" />,
    dataIndex: 'amount',
    width: '28%',
    ellipsis: true,
    render: text => (
      <div>
        <CurrencyFormatWithTitle
          value={Number(text)}
          currency={invoiceCurrency || 'USD'}
          currencySign="accounting"
        />
      </div>
    ),
  },
  {
    key: 'transactionComment',
    title: <FormattedMessage id="invoice.transactionHistory.description" />,
    dataIndex: 'comment',
    width: '30%',
    ellipsis: true,
  },
];

const transformInvoiceTransactionData = invoiceTransactionHistory => {
  if (!invoiceTransactionHistory?.transactions?.length) return [];

  return invoiceTransactionHistory.transactions.map(
    (invoiceTransaction, index) => ({
      ...invoiceTransaction,
      key: `${invoiceTransactionHistory.id}-transaction${index}`,
    })
  );
};

export const useInvoiceTransactionsTable = (
  invoiceTransactionHistory,
  invoiceCurrency
) => {
  const invoiceTransactionsColumns = useMemo(
    () => createInvoiceTransactionsColumns(invoiceCurrency),
    [invoiceCurrency]
  );
  const invoiceTransactionsTableData = useMemo(
    () => transformInvoiceTransactionData(invoiceTransactionHistory),
    [invoiceTransactionHistory]
  );

  return {
    invoiceTransactionsColumns,
    invoiceTransactionsTableData,
  };
};
